export enum EmailOptions {
  REPORT_BUG = 'Report a bug',
  GET_IN_TOUCH = 'Get in touch',
}
